import React, { Suspense } from 'react';

// Global styles
import './App.scss';

function App() {
  // Get the id of an iframe with the 'activity-iframe' class
  // I may need to loop through a querySelectorAll if we end up with multiple activities on one page
  let activityIframe = window.parent.document.querySelector(
    'iframe.activity-iframe'
  );
  let iframeId;
  if (activityIframe) {
    iframeId = window.parent.document.querySelector('iframe.activity-iframe')
      .id;
  } else {
    console.warn('No Activity iframe found.');
  }

  // Evaluate whether the iframe id matches a string, and then load and render the correct component
  switch (iframeId) {
    case 'forces-of-flight-air-activity':
      const FofaContainerState = React.lazy(() =>
        import('./context/forcesOfFlightAirContext/FofaContainerState')
      );
      const ForcesOfFlightAirState = React.lazy(() =>
        import('./context/forcesOfFlightAirContext/ForcesOfFlightAirState')
      );
      const ActivityForcesOfFlightAir = React.lazy(() =>
        import('./components/forcesOfFlightAir/ActivityForcesOfFlightAir')
      );
      return (
        <Suspense
          fallback={
            <div style={{ textAlign: 'center', paddingTop: '1rem' }}>
              Loading...
            </div>
          }
        >
          <FofaContainerState>
            <ForcesOfFlightAirState>
              <ActivityForcesOfFlightAir />
            </ForcesOfFlightAirState>
          </FofaContainerState>
        </Suspense>
      );
    case 'how-wings-work-activity':
      const HowWingWorkState = React.lazy(() =>
        import('./context/howWingsWorkContext/HowWingsWorkState')
      );
      const ActivityHowWingsWork = React.lazy(() =>
        import('./components/howWingsWork/ActivityHowWingsWork')
      );
      return (
        <Suspense
          fallback={
            <div style={{ textAlign: 'center', paddingTop: '1rem' }}>
              Loading...
            </div>
          }
        >
          <HowWingWorkState>
            <ActivityHowWingsWork />
          </HowWingWorkState>
        </Suspense>
      );
    case 'shock-waves-activity':
      // Shock Waves has no state object
      const ActivityShockWaves = React.lazy(() =>
        import('./components/shockWaves/ActivityShockWaves')
      );
      return (
        <Suspense
          fallback={
            <div style={{ textAlign: 'center', paddingTop: '1rem' }}>
              Loading...
            </div>
          }
        >
          <ActivityShockWaves />
        </Suspense>
      );
    case 'what-is-buoyancy-activity':
      // What is Buoyancy has no state object
      const ActivityWhatIsBuoyancy = React.lazy(() =>
        import('./components/whatIsBuoyancy/ActivityWhatIsBuoyancy')
      );
      return (
        <Suspense
          fallback={
            <div style={{ textAlign: 'center', paddingTop: '1rem' }}>
              Loading...
            </div>
          }
        >
          <ActivityWhatIsBuoyancy />
        </Suspense>
      );
    case 'bernoulli-principle-activity':
      const BernoulliPrincipleState = React.lazy(() =>
        import('./context/bernoulliPrincipleContext/BernoulliPrincipleState')
      );
      const ActivityBernoulliPrinciple = React.lazy(() =>
        import('./components/bernoulliPrinciple/ActivityBernoulliPrinciple')
      );
      return (
        <Suspense
          fallback={
            <div style={{ textAlign: 'center', paddingTop: '1rem' }}>
              Loading...
            </div>
          }
        >
          <BernoulliPrincipleState>
            <ActivityBernoulliPrinciple />
          </BernoulliPrincipleState>
        </Suspense>
      );
    case 'gravity-in-orbit-activity':
      const GravityInOrbitState = React.lazy(() =>
        import('./context/gravityInOrbitContext/GravityInOrbitState')
      );
      const ActivityGravityInOrbit = React.lazy(() =>
        import('./components/gravityInOrbit/ActivityGravityInOrbit')
      );
      return (
        <Suspense
          fallback={
            <div style={{ textAlign: 'center', paddingTop: '1rem' }}>
              Loading...
            </div>
          }
        >
          <GravityInOrbitState>
            <ActivityGravityInOrbit />
          </GravityInOrbitState>
        </Suspense>
      );
    case 'weight-on-other-worlds-activity':
      // What Would You Weigh has no state object
      const ActivityWeightOnOtherWorlds = React.lazy(() =>
        import('./components/weightOnOtherWorlds/ActivityWeightOnOtherWorlds')
      );
      return (
        <Suspense
          fallback={
            <div style={{ textAlign: 'center', paddingTop: '1rem' }}>
              Loading...
            </div>
          }
        >
          <ActivityWeightOnOtherWorlds />
        </Suspense>
      );
    case 'forces-of-flight-space-activity':
      const ForceOfFlightSpaceState = React.lazy(() =>
        import('./context/forcesOfFlightSpaceContext/ForceOfFlightSpaceState')
      );
      const ActivityForcesOfFlightSpace = React.lazy(() =>
        import('./components/forcesOfFlightSpace/ActivityForcesOfFlightSpace')
      );
      return (
        <Suspense
          fallback={
            <div style={{ textAlign: 'center', paddingTop: '1rem' }}>
              Loading...
            </div>
          }
        >
          <ForceOfFlightSpaceState>
            <ActivityForcesOfFlightSpace />
          </ForceOfFlightSpaceState>
        </Suspense>
      );
    case 'vortex-drag-activity':
      const VortexDragState = React.lazy(() =>
        import('./context/vortexDragContext/VortexDragState')
      );
      const ActivityVortexDrag = React.lazy(() =>
        import('./components/vortexDrag/ActivityVortexDrag')
      );
      return (
        <Suspense
          fallback={
            <div style={{ textAlign: 'center', paddingTop: '1rem' }}>
              Loading...
            </div>
          }
        >
          <VortexDragState>
            <ActivityVortexDrag />
          </VortexDragState>
        </Suspense>
      );
    case 'hypersonic-vehicles-activity':
      const HypersonicVehiclesState = React.lazy(() =>
        import('./context/hypersonicVehiclesContext/HypersonicVehiclesState')
      );
      const ActivityHypersonicVehicles = React.lazy(() =>
        import('./components/hypersonicVehicles/ActivityHypersonicVehicles')
      );
      return (
        <Suspense
          fallback={
            <div style={{ textAlign: 'center', paddingTop: '1rem' }}>
              Loading...
            </div>
          }
        >
          <HypersonicVehiclesState>
            <ActivityHypersonicVehicles />
          </HypersonicVehiclesState>
        </Suspense>
      );
    case 'airplane-instruments-activity':
      const AirplaneInstrumentsState = React.lazy(() =>
        import('./context/airplaneInstrumentsContext/AirplaneInstrumentsState')
      );
      const ActivityAirplaneInstruments = React.lazy(() =>
        import('./components/airplaneInstruments/ActivityAirplaneInstruments')
      );
      return (
        <Suspense
          fallback={
            <div style={{ textAlign: 'center', paddingTop: '1rem' }}>
              Loading...
            </div>
          }
        >
          <AirplaneInstrumentsState>
            <ActivityAirplaneInstruments />
          </AirplaneInstrumentsState>
        </Suspense>
      );
    case 'orbital-motion-activity':
      // Orbital Motion has no state object
      const ActivityOrbitalMotion = React.lazy(() =>
        import('./components/orbitalMotion/ActivityOrbitalMotion')
      );
      return (
        <Suspense
          fallback={
            <div style={{ textAlign: 'center', paddingTop: '1rem' }}>
              Loading...
            </div>
          }
        >
          <ActivityOrbitalMotion />
        </Suspense>
      );
    case 'three-types-of-engine-activity':
      const ThreeTypesOfEngineState = React.lazy(() =>
        import('./context/threeTypesOfEngineContext/ThreeTypesOfEngineState')
      );
      const ActivityThreeTypesOfEngine = React.lazy(() =>
        import('./components/threeTypesOfEngine/ActivityThreeTypesOfEngine')
      );
      return (
        <Suspense
          fallback={
            <div style={{ textAlign: 'center', paddingTop: '1rem' }}>
              Loading...
            </div>
          }
        >
          <ThreeTypesOfEngineState>
            <ActivityThreeTypesOfEngine />
          </ThreeTypesOfEngineState>
        </Suspense>
      );
    default:
      // TODO: This Default is for Development only, to give us easy access to the activities. We'll need something else for Production
      return (
        <main>
          <h1 className={`h3`}>Select an Activity</h1>
          <ol>
            <li>
              <a href="forces-of-flight.html">Forces of Flight: Air</a>
            </li>
            <li>
              <a href="how-wings-work.html">How Wings Work</a>
            </li>
            <li>
              <a href="shock-waves.html">Shock Waves</a>
            </li>
            <li>
              <a href="what-is-buoyancy.html">What is Buoyancy</a>
            </li>
            <li>
              <a href="bernoulli-principle.html">Bernoulli Principle</a>
            </li>
            <li>
              <a href="gravity-in-orbit.html">Gravity In Orbit</a>
            </li>
            <li>
              <a href="weight-on-other-worlds.html">Weight On Other Worlds</a>
            </li>
            <li>
              <a href="forces-of-flight-space.html">Forces of Flight: Space</a>
            </li>
            <li>
              <a href="vortex-drag.html">Vortex Drag</a>
            </li>
            <li>
              <a href="hypersonic-vehicles.html">Hypersonic Vehicles</a>
            </li>
            <li>
              <a href="airplane-instruments.html">Airplane Instruments</a>
            </li>
            <li>
              <a href="orbital-motion.html">Orbital Motion</a>
            </li>
            <li>
              <a href="three-types-of-engine.html">Three Types Of Engine</a>
            </li>
          </ol>
        </main>
      );
  }
}

export default App;
